module.exports = __webpack_public_path__ + "static/monei_pay_group_en_2-d028b7ac8d0439edbd5e3b8120f16e69.png";